import { BModal, BToast } from 'bootstrap-vue'
import util from '@/util'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import { mapState } from 'vuex'
import pagination from '@/components/layout/pagination/Pagination.vue'
import { faturaMixin } from '@/modules/faturas/mixins'
import mensagens from '@/util/mensagens'

export default {
  name: 'listagem-faturas',
  props: {
    faturas: {
      type: Array,
      default: () => []
    },
    obterFaturas: {
      type: Function,
      required: true
    },
    componentePaginacao: {
      type: Object,
      required: true
    },
    componenteOrdenacao: {
      type: Object,
      required: false
    },
    colunas: {
      type: Array,
      required: true
    },
    flagsDeControle: {
      type: Object,
      required: true
    }
  },
  components: {
    pagination,
    'b-modal': BModal,
    'b-toast': BToast,
    'default-table': defaultTable
  },
  mixins: [faturaMixin],

  computed: {
    ...mapState('pagination', ['registrosPorPagina']),
    tabelaSemRegistros () {
      return this.faturas.length === 0
    },
    listaFaturas: {
      get () {
        return this.faturas
      },
      set (faturas) {
        this.$emit('input', faturas)
      }
    },
    flags: {
      get () {
        return this.flagsDeControle
      },
      set (flagsDeControle) {
        this.$emit('input', flagsDeControle)
      }
    }
  },

  data: () => {
    return {
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
  },

  methods: {
    async executarBuscaFaturas () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const faturas = await this.obterFaturas()
        this.listaFaturas = faturas
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }

      this.definirFlagCarregandoDados(false, '')
    },
    definirClasseLinha (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center trCorTextoPadrao'
      }
      return 'trCorTextoPadrao'
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flags.carregandoDados.status = status
      this.flags.carregandoDados.mensagem = mensagem
    },
    buscarListaFaturas () {
      this.executarBuscaFaturas()
      this.componentePaginacao.pagina = 1
    },
    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.executarBuscaFaturas()
    },
    formatarValorMonetario (valor) {
      return util.formatarValorMonetarioComCifrao(valor)
    }
  }
}
